export default __webpack_public_path__ + "static/Logo_blue-20d8f03991a6236d797552c94f4dbcd1.svg";